module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_AuthorsNote"
    }
  }, [_vm._v("Authors’ Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Services after the Grouping based on 1924 Service Timetable")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Location Analysis")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bargoed")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Groesfaen")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Darran & Deri")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ogilvie Village Halt/Ogilvie Colliery")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fochriw")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pantywaun Halt")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dowlais Top")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pant")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02#ch2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pontsticill Junction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3"), _c('span', {
    staticClass: "space"
  }, [_vm._v("Pant to Dowlais Central")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#ch3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pant")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#ch3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pantyscallog")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#ch3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dowlais (Lloyd Street)/Dowlais Central")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#ch3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passenger & Freight Working")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-h3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter03#ch3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dowlais Iron Works")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0